import React from 'react';
import { withStyles } from '@material-ui/core';
import styles from './pageHeader.styles';
import { Ellipsis } from '../../shared/ellipsis';

export const PAGE_HEADER_HEIGHT = 24;

const PageHeaderC = ({ classes, documentName }) => (
  <div className={classes.pageHeader} style={{ height: PAGE_HEADER_HEIGHT }}>
    <Ellipsis>{documentName}</Ellipsis>
  </div>
);

export default withStyles(styles)(PageHeaderC);
